import { useGetOrderByIdBasicQuery, Instacart_Care_Tools_V1_ServiceUser } from '../../api'
import { CustomerOrderHistoryViewAccessControl } from '../../access-control/customersAndOrdersAdminAccess.configuration'
import { useDomainAccessControl } from '../domain/accessControl'

export const useGetOrderByIdBasic = (orderId: string | null) => {
  const hasAccess = useDomainAccessControl()
  // The mesh requires care_admin.customers.orders.view for GetOrderByIdBasic.
  const canViewOrders = hasAccess(CustomerOrderHistoryViewAccessControl)

  const { data, loading } = useGetOrderByIdBasicQuery({
    variables: {
      orderId: orderId ?? '',
      serviceUser: Instacart_Care_Tools_V1_ServiceUser.ServiceUserIppCxAdmin,
    },
    fetchPolicy: 'cache-and-network',
    skip: !orderId || !canViewOrders,
  })

  const order = data?.instacart_care_tools_v1_CareToolsService_GetOrderByIdBasic?.order ?? null

  return { data: order, loading }
}
